import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import apiService from "../../../global/common/environment";
import axiosInstance from "../../../global/common/interceptor";
import "./OfferLetter.scss";

const OfferLetter = () => {
  const [Users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  useEffect(() => {
    getAllUsers();
  }, []);

  useEffect(() => {
    const results = Users.filter(user =>
      user?.userId?.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.userId?.lastName?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(results);
  }, [searchTerm, Users]);

  const getAllUsers = async () => {
    try {
      const res = await axiosInstance.get(apiService.getOfferLetterUser);
      setUsers(res.data);
      setFilteredUsers(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const changeStatus = async (id, status) => {
    try {
      const res = await axiosInstance.put(apiService.getOfferLetterUser(id), {
        verified: status,
      });
      getAllUsers();
    } catch (err) {
      console.log(err);
    }
  };

  const handleViewDetails = (User) => {
    setSelectedUser(User);
    setShowDetails(true);
  };

  const handleCloseModal = () => {
    setShowDetails(false);
    setSelectedUser(null);
  };

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const nextPage = () => setCurrentPage(prev => (prev < totalPages ? prev + 1 : prev));
  const prevPage = () => setCurrentPage(prev => (prev > 1 ? prev - 1 : prev));

  return (
    <div className="admin-dashboard-container">
      <h1 className="dashboard-title">MakeStudyOnline Offer Letter Users</h1>

      {/* Search */}
      <div className="search-container">
        <input 
          type="text" 
          placeholder="Search by name..." 
          value={searchTerm} 
          onChange={(e) => setSearchTerm(e.target.value)} 
          className="search-input" 
        />
      </div>

      <table className="admin-dashboard-table">
        <thead>
          <tr>
          <th>S.No</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Course Title</th>
            <th>Phone</th>
            <th>View</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.length > 0 ? (
            filteredUsers
              .slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage)
              .map((User, index) => (
                <tr key={index}>
                   <td>{(currentPage - 1) * usersPerPage + index + 1}</td>
                  <td>{User?.userId?.firstName || "N/A"}</td>
                  <td>{User?.userId?.lastName || "N/A"}</td>
                  <td>{User?.userId?.email || "N/A"}</td>
                  <td>{User?.courseId?.title || "N/A"}</td>
                  <td>{User?.userId?.phoneNumber || "N/A"}</td>
                  <td>
                    <button
                      className="view-details-btn"
                      onClick={() => handleViewDetails(User)}
                    >
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan="6">No Users found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1} className="pagination-btn">Prev</button>
        {Array.from({ length: Math.min(2, totalPages) }, (_, i) => i + currentPage)
          .map(page => (
            <button 
              key={page} 
              onClick={() => setCurrentPage(page)}
              className={page === currentPage ? "pagination-btn active" : "pagination-btn"}
            >
              {page}
            </button>
          ))}
        <button onClick={nextPage} disabled={currentPage === totalPages} className="pagination-btn">Next</button>
      </div>

      {/* Modal for user details */}
      {showDetails && selectedUser && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>
              &times;
            </span>
            <h2>User Details</h2>
            <p><strong>First Name:</strong> {selectedUser?.userId?.firstName || "N/A"}</p>
            <p><strong>Last Name:</strong> {selectedUser?.userId?.lastName || "N/A"}</p>
            <p><strong>Email:</strong> {selectedUser?.userId?.email || "N/A"}</p>
            <p><strong>Country:</strong> {selectedUser?.userId?.nationality || "N/A"}</p>
            <p><strong>Phone:</strong> {selectedUser?.userId?.phoneNumber || "N/A"}</p>
            <p><strong>Date of Birth:</strong> {selectedUser?.userId?.dob || "N/A"}</p>
            <p><strong>State:</strong> {selectedUser?.userId?.state || "N/A"}</p>
            <p><strong>City:</strong> {selectedUser?.userId?.city || "N/A"}</p>
            <p><strong>Postal Code:</strong> {selectedUser?.userId?.postalCode || "N/A"}</p>
            <p><strong>Management Experience:</strong> {selectedUser?.userId?.managementExperience || "N/A"}</p>
            <p><strong>Education Level:</strong> {selectedUser?.userId?.educationLevel || "N/A"}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfferLetter;
